<app-menu-common url="sales"></app-menu-common>

@if (formGroup) {
  <app-action-bar [canSave]="formGroup.valid" form="mainForm" (submitEmitter)="onSubmit($event)" >
    <smart-input class="product-jump" width="140px" type="number" placeholder="Id produit" icon="link" title="Aller à un autre produit : taper son numéro, puis Entrée ou l'icône"
      [iconClass]="jumpId ? 'custom-icon-button primary' : 'custom-icon-button primary jump-off'"
      (valueChange)="onJumpIdChange($event)" (enterPressed)="goToProduct()" (iconClicked)="goToProduct()" />
    <span class="product_id">Produit #{{ formGroup.value.id }}</span>
  </app-action-bar>
  <div class="pagecontent"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [class.drag-over]="isDragging">
    @if (isDragging) {
      <div class="drop-overlay">
        <mat-icon>image</mat-icon>
        <span>Déposer l'image ici</span>
      </div>
    }
    <form [formGroup]="formGroup">
      <div class="header maincontent " formGroupName="lnk_template" [ngClass]="formGroup.get('lnk_template')?.get('has_variants')?.value ? 'template' : 'flat_product'" >
        <app-product-tpl-general  [canEditGeneral]="formGroup.get('lnk_template')?.get('has_variants')?.value ? false : true" [attachs_images]=" formGroup.get('lnk_template')?.get('has_variants')?.value ?   template_attachs_images : attachs_images"  (reload)="onSubmit(null)"  ></app-product-tpl-general>
      </div>
    </form>
    <form id="mainForm"  [formGroup]="formGroup"  [ngClass]="formGroup.get('lnk_template')?.get('has_variants')?.value ? 'specific' : 'flat_product'" [formGroup] = "formGroup" (ngSubmit)="onSubmit('')">
      <div class="maincontent" >
        <div class="flexgrid description">
          <!-- Produit + Image + Attributs : uniquement pour les variantes (pas flat_product) -->
          <!-- ≥1880 L1 : Nom (2 cols) | Image (1 col, span 2 lignes) -->
          <!-- ≥1880 L2 : Attributs (2 cols) | (fin image) -->
          @if (!flat_product) {
            <div class="gridChild flexrow product-name-row">
              <div class="col22">
                <span>Produit&nbsp;&nbsp;#{{ formGroup.value.id }}&nbsp;&nbsp;</span>
              </div>
              <div class="col75">
                <input class="smart-input" style="width: 100%;" type="text" formControlName="name" placeholder="Nom du produit">
              </div>
            </div>
            <div class="gridChild product-default-image">
              @if (defaultProductImage) {
                @if (defaultProductImage.thumbnailLocalUrl) {
                  <img [src]="defaultProductImage.thumbnailLocalUrl"
                    [alt]="defaultProductImage.name || 'Image par défaut'" />
                }
              }
              @if (!defaultProductImage?.thumbnailLocalUrl) {
                <div class="no-image-placeholder">
                  Aucune image
                </div>
              }
            </div>
            <div class="gridChild flexrow product-attr-row">
              <div class="col22">
                <div>Attributs</div>
              </div>
              <div class="col75">
                {{formGroup.value.attributestring}}
              </div>
            </div>
          }
          <!-- ≥1880 L1 : Options | Réf. Interne | Mémo (span 2 lignes) -->
          <!-- ≥1880 L2 : Réf. Fabricant | Réf. Fournisseur | (fin mémo) -->
          <div class="gridChild flexrow checkbox-row">
            <div class="col22">
              <div>Options</div>
            </div>
            <div class="col75 options-container">
              <label class="checkbox-label">
                <input type="checkbox" formControlName="is_purchased">
                <span>Acheté</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" formControlName="is_sold">
                <span>Vendu</span>
              </label>
            </div>
          </div>
          <div class="gridChild flexrow">
            <div class="col22">
              <div>Réf. Interne</div>
            </div>
            <div class="col75">
              <input class="smart-input" style="width: 200px;" type="text" formControlName="partnbloc">
            </div>
          </div>
          <div class="gridChild memo-cell">
            @if (defaultMemoControl) {
              <mat-form-field appearance="outline" class="w-full" style="width: 100%;">
                <mat-label>Mémo</mat-label>
                <textarea matInput [formControl]="defaultMemoControl" rows="3"></textarea>
              </mat-form-field>
            }
          </div>
          <div class="gridChild flexrow">
            <div class="col22">
              <div>Réf. Fabricant</div>
            </div>
            <div class="col75">
              <input class="smart-input" style="width: 200px;" type="text" formControlName="partnbman">
            </div>
          </div>
          <div class="gridChild flexrow">
            <div class="col22">
              <div>Réf. Fournisseur</div>
            </div>
            <div class="col75">
              <input class="smart-input" style="width: 200px;" type="text" formControlName="partnbsup">
            </div>
          </div>
          @if (cufsStructure.length && cufGroup) {
            <div class="cufGroup  gridChild flexrow" >
              <app-cuf [inline]="false" class="cufs" [cufsStructure]="cufsStructure" [cufGroup]="cufGroup"></app-cuf>
            </div>
          }
          <!-- Tableau unifié : prix d'achat + marges par fournisseur -->
          <div class="gridChild purchase-margin-table-container">
            <table class="purchase-margin-table">
              <thead>
                <tr>
                  <th class="cell-pm-supplier">Fournisseur</th>
                  <th class="cell-pm-price">Prix Achat HT</th>
                  <th class="cell-pm-margin">Marge</th>
                  <th class="cell-pm-margin">Tx Marge</th>
                  <th class="cell-pm-margin">Tx Marque</th>
                </tr>
              </thead>
              <tbody>
                @for (pph of purchasePriceHistsFormArray?.controls; track $index; let isEven = $even) {
                  <tr [class.even]="isEven" [class.odd]="!isEven">
                    <td class="cell-pm-supplier">{{ pph.get('lnk_supplier')?.get('name')?.value }}</td>
                    <td class="cell-pm-price">
                      {{ $safeNavigationMigration(pph.get('price')?.value) | number:'1.2-2' }}&nbsp;€&nbsp;/&nbsp;{{ getPackagingName(formGroup.get('lnk_template')?.get('baseuom')?.value ?? 1) }}
                      @if (getUnitPriceFromValue($safeNavigationMigration(pph.get('price')?.value)) && get_tpl_unitpriceuom()) {
                        &nbsp;(&nbsp;{{ getUnitPriceFromValue($safeNavigationMigration(pph.get('price')?.value)) | number:'1.2-2' }}&nbsp;€&nbsp;/&nbsp;{{ get_tpl_unitpriceuom() }}&nbsp;)
                      }
                    </td>
                    <td class="cell-pm-margin">{{ getMarginRow(pph).marge !== null ? (getMarginRow(pph).marge | number:'1.2-2') + ' €' : '—' }}</td>
                    <td class="cell-pm-margin">{{ getMarginRow(pph).marge_pct !== null ? (getMarginRow(pph).marge_pct | number:'1.2-2') + ' %' : '—' }}</td>
                    <td class="cell-pm-margin">{{ getMarginRow(pph).marque_pct !== null ? (getMarginRow(pph).marque_pct | number:'1.2-2') + ' %' : '—' }}</td>
                  </tr>
                }
                @if (!purchasePriceHistsFormArray?.length) {
                  <tr><td colspan="5" class="cell-pm-empty">Aucun prix d'achat</td></tr>
                }
              </tbody>
            </table>
          </div>
          <div class="gridChild flexrow price-section">
            <div class="col22">
              <div>Prix Vente HT</div>
            </div>
            <div class="col75">
              <input-price formControlName="price_taxx" (priceChange)="on_price_taxx_change()"></input-price>
              <span class="currency">€&nbsp;/&nbsp;</span>
              <span class="tpl_uom">{{ getPackagingName(formGroup.get('lnk_template')?.get('baseuom')?.value ?? 1) }}</span>
              @if (getUnitPrice('price_taxx') &&  get_tpl_unitpriceuom()) {
                <span >&nbsp;(&nbsp;</span>
                <span class="sale_unit_pricex unit-price-text">{{ getUnitPrice('price_taxx') | number:'1.2-2' }}&nbsp;€&nbsp;/&nbsp;{{ get_tpl_unitpriceuom() }}</span>
                <span >)&nbsp;</span>
              }
            </div>
          </div>
          <div class="gridChild flexrow price-section">
            <div class="col22">
              <div>Prix Vente TTC</div>
            </div>
            <div class="col75">
              <input-price formControlName="price_taxi" (priceChange)="on_price_taxi_change()"></input-price>
              <span class="currency">€&nbsp;/&nbsp;</span>
              <span class="tpl_uom">{{ getPackagingName(formGroup.get('lnk_template')?.get('baseuom')?.value ?? 1) }}</span>
              @if (getUnitPrice('price_taxi') &&  get_tpl_unitpriceuom()) {
                <span >&nbsp;(&nbsp;</span>
                <span  class="sale_unit_pricei unit-price-text">{{ getUnitPrice('price_taxi') | number:'1.2-2' }}&nbsp;€&nbsp;/&nbsp;{{ get_tpl_unitpriceuom() }}</span>
                <span >)&nbsp;</span>
              }
            </div>
          </div>
        </div>
        <!-- section des prix vente avec les remise -->
        <div class="salesprices-table-container">
          @if (salespartnerpricelsFormArray?.length) {
            <div class="salesprices-table">
              <!-- Header -->
              <div class="salesprices-header">
                <div class="cell cell-spname">Tarif</div>
                <div class="cell cell-typdis">Type Remise</div>
                <div class="cell cell-value">Valeur</div>
              </div>
              <!-- Rows -->
              @for (spp of salespartnerpricelsFormArray?.controls; track spp; let i = $index; let isEven = $even) {
                <div
                  [class]="'salesprices-row' + (isEven ? ' even' : ' odd')">
                  <div class="cell cell-spname">
                    {{ spp.get('lnk_salespartnerprice')?.get('name')?.value || 'Tarif ' + spp.get('id_partnerprice')?.value }}
                  </div>
                  <div class="cell cell-typdis">
                    {{ getDiscName($safeNavigationMigration(spp.get('strategy')?.value)) }}
                  </div>
                  <div class="cell cell-value">
                    {{ spp.get('param')?.value }}@if (spp.get('strategy')?.value === 0) {
                    <span>%</span>
                    }@if (spp.get('strategy')?.value === 1 || spp.get('strategy')?.value === 2) {
                    <span> €</span>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
      <!-- <div class="cell cell-typdis">
      <ng-container [ngSwitch]="spp.get('strategy')?.value">
        <span *ngSwitchCase="0">%</span>
        <span *ngSwitchCase="1">€</span>
        <span *ngSwitchCase="2">Fixe</span>
        <span *ngSwitchDefault>-</span>
      </ng-container>
    </div> -->
    <div class="packaging-ecopart-row">
      <!-- section des packagings -->
      <div class="packaging-table-container">
        <smart-select width="18rem" height="2.1875rem" [items]="packaging" placeholder="Ajouter un conditionnement" bindLabel="name" bindValue="id" (selectionChange)="addPackaging($event)"></smart-select>
        @if (packagingsFormArray?.length) {
          <table class="packaging-table">
            <thead>
              <tr>
                <th class="cell-suppress"></th>
                <th class="cell-default">Défaut</th>
                <th class="cell-is_purchasable">Achat</th>
                <th class="cell-is_sellable">Vente</th>
                <th class="cell-pkname">Packaging</th>
                <th class="cell-qty_base_uom">Qté packaging</th>
                <th class="cell-qty_unit_uom">U. mesure</th>
                <th class="cell-barcode">Code Barre</th>
                <th class="cell-price">Vente HT</th>
                <th class="cell-price">Vente TTC</th>
              </tr>
            </thead>
            <tbody>
              @for (pkg of packagingsFormArray?.controls; track pkg; let i = $index; let isEven = $even) {
                <tr
                  [class.even]="isEven" [class.odd]="!isEven"
                  [class.is_default]="pkg.get('is_default')?.value">
                  <td class="cell-suppress">
                    <button type="button" class="custom-icon-button error" (click)="removePackaging(i, pkg.value.id ?? 0)"
                      [disabled]="pkg.get('is_default')?.value || isBasePackaging(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                  <td class="cell-default">
                    <label class="radio-label">
                      <input type="radio" name="is_default_packaging" [checked]="$safeNavigationMigration(pkg.get('is_default')?.value)" (change)="setDefaultPackaging(i)">
                    </label>
                  </td>
                  <td class="cell-is_purchasable">
                    <input type="checkbox" [formControl]="$any(pkg.get('is_purchasable'))">
                  </td>
                  <td class="cell-is_sellable">
                    <input type="checkbox" [formControl]="$any(pkg.get('is_sellable'))">
                  </td>
                  <td class="cell-pkname">{{ getPackagingName($safeNavigationMigration(pkg.get('packaging')?.value)) }}</td>
                  <td class="cell-qty_base_uom">
                    <div class="cell-inner">
                      <input class="smart-input" [class.error]="pkg.get('qtybaseuom')?.invalid && pkg.get('qtybaseuom')?.touched"
                        type="number" step="1" [formControl]="$any(pkg.get('qtybaseuom'))" (input)="on_qtybaseuom_change(i)" placeholder="Qté">
                      <span class="uom-label">{{ getPackagingName(formGroup.get('lnk_template')?.get('baseuom')?.value ?? 1) }}</span>
                    </div>
                  </td>
                  <td class="cell-qty_unit_uom">
                    <div class="cell-inner">
                      <input class="smart-input qty_unit_uom_input" type="number" step="1" [formControl]="$any(pkg.get('qtyunitpriceuom'))" placeholder="" (input)="on_qtyunitpriceuom_change(i)">
                      <span class="uom-label">{{ getPackagingName(formGroup.get('lnk_template')?.get('unitpriceuom')?.value ?? 1) }}</span>
                    </div>
                  </td>
                  <td class="cell-barcode">
                    <input class="smart-input" type="text" [formControl]="$any(pkg.get('barcode'))" placeholder="Code barre" (focus)="$any($event.target).select()">
                  </td>
                  <td class="cell-price">
                    {{ $safeNavigationMigration(formGroup.get('price_taxx')?.value) * $any(pkg.get('qtybaseuom')).value | number:'1.2-2' }} €
                  </td>
                  <td class="cell-price">
                    {{ $safeNavigationMigration(formGroup.get('price_taxi')?.value) * $any(pkg.get('qtybaseuom')).value | number:'1.2-2' }} €
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
      <!-- section des éco-participations -->
      <div class="ecopart-table-container">
        <smart-select width="28rem" height="2.1875rem" [items]="ecopartActiveTypes" placeholder="Ajouter une éco-participation" bindLabel="name" bindValue="id" (selectionChange)="addEcopart($event)"></smart-select>
        <table class="ecopart-table">
          <thead>
            <tr>
              <th class="cell-suppress"></th>
              <th class="cell-epname">Type d'éco-participation</th>
              <th class="cell-epvalue">HT / {{ getPackagingName(formGroup.get('lnk_template')?.get('baseuom')?.value ?? 1) || 'unité' }}</th>
            </tr>
          </thead>
          <tbody>
            @for (ep of lnkEcopartsFormArray.controls; track ep; let i = $index; let isEven = $even) {
              <tr
                [class.even]="isEven" [class.odd]="!isEven"
                [formGroup]="$any(ep)">
                <td class="cell-suppress">
                  <button type="button" class="custom-icon-button error" (click)="removeEcopart(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
                <td class="cell-epname">
                  {{ ep.get('name')?.value || 'Filière ' + ep.get('id')?.value }}
                  @if (ecopartDetail(ep); as detail) {
                    <br><small>{{ detail }}</small>
                  }
                </td>
                <td class="cell-epvalue">
                  <input-price formControlName="value"></input-price>
                </td>
              </tr>
            }
            @if (!lnkEcopartsFormArray.length) {
              <tr >
                <td class="ecopart-empty" colspan="3">Aucune écotax pour ce produit</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div> <!-- fin packaging-ecopart-row -->
    <!-- section gestion documentaire produit -->
    <div class="header_document">
      <input #fileInput type="file" hidden (change)="onFileSelected($event)">
      <button type="button" id="upload-button" class="custom-filled-button" (click)="fileInput.click()" aria-label="uploader un fichier">
        <mat-icon>upload</mat-icon> Ajoutez un fichier
      </button>
      <smart-input width="350px" autofocus initialValue="" placeholder="Upload Vidéo Youtube" icon="upload" iconClass="custom-icon-button primary" (enterPressed)="uploadYoutubeVideo($event)" (iconClicked)="uploadYoutubeVideo($event)" />
    </div>
    <app-image-carousel [attachs]="attachs_images" />
    <!-- section historique des prix de vente -->
    @if (salesPriceHists.length) {
      <div class="salespriceshist-table-container">
        <div class="price-hist-title">Historique des prix de vente</div>
        <table class="salespriceshist-table">
          <thead>
            <tr>
              <th class="cell-ph-active">Actif</th>
              <th class="cell-ph-date">Date</th>
              <th class="cell-ph-price">HT</th>
              <th class="cell-ph-price">TTC</th>
              <th class="cell-ph-ecopart">Éco-part</th>
              <th class="cell-ph-name">Description</th>
            </tr>
          </thead>
          <tbody>
            @for (sph of salesPriceHists; track sph; let isEven = $even) {
              <tr
                [class.even]="isEven" [class.odd]="!isEven" [class.is_default]="sph.is_active">
                <td class="cell-ph-active">
                  @if (sph.is_active) {
                    <span class="badge-active">Actif</span>
                  }
                  @if (!sph.is_active) {
                    <span class="badge-inactive">—</span>
                  }
                </td>
                <td class="cell-ph-date">{{ $safeNavigationMigration(sph.lnk_sales_pricelist?.datstart) | date:'dd/MM/yy HH:mm' }}</td>
                <td class="cell-ph-price">{{ sph.price_taxx | number:'1.4-4' }} €</td>
                <td class="cell-ph-price">{{ sph.price_taxi | number:'1.4-4' }} €</td>
                <td class="cell-ph-ecopart">{{ formatEcopart(sph.ecoparts) }}</td>
                <td class="cell-ph-name">{{ sph.lnk_sales_pricelist?.name }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</form>
<!-- section images template (consultation uniquement) -->
@if (template_attachs_images.length) {
  <div class="maincontent template">
    <app-image-carousel [attachs]="template_attachs_images" [canEdit]="false" />
  </div>
}
</div>
}
